// Schweizerdeutsch – eigenständige Übersetzung
const deCH = {
  common: {
    loading: "Ladt...",
    back: "Zrugg",
    next: "Witer",
    save: "Spichere",
    cancel: "Abbreche",
    close: "Schliesse",
    send: "Schicke",
    submit: "Abschicke",
    yes: "Ja",
    no: "Nei",
    error: "Fehler",
    success: "Erfolg",
    search: "Sueche",
    more: "Meh",
    less: "Weniger",
    optional: "optional",
    required: "Pflichtfäld",
    perMonth: "/ Monet",
    oneTime: "einmalig",
    free: "Gratis",
    skip: "\u00DCberspringe",
    pleaseWait: "Bitte warte...",
    backToHome: "Zrugg zur Startsyte",
    learnMore: "Meh erfahre",
    email: "E-Mail",
    phone: "Telefon",
    password: "Passwort",
    name: "Name",
    selected: "usgw\u00E4hlt",
    available: "verf\u00FCegbar",
    used: "bruucht",
    of: "vo",
    question: "Frag",
    craftBusiness: "Handwerksbetrieb",
    forCraftBusinesses: "F\u00FCr Handwerksbetrieb",
    projectInquiry: "Projektafrag",
    projectInquiries: "Projektafrage",
  },
  header: {
    dashboard: "Dashboard",
    signOut: "Abm\u00E4lde",
    completeProfile: "Profil fertig mache",
    submitInquiry: "Projektafrag stelle",
    signIn: "Anm\u00E4lde",
    menuOpen: "Men\u00FC \u00F6ffne",
    menuClose: "Men\u00FC schliesse",
    registerAsCraft: "Als Handwerksbetrieb registriere",
  },
  footer: {
    tagline: "Qualifizierti Projektafrage.\nF\u00FCr usgw\u00E4hlti Handwerksbetrieb.",
    motto: "Finde \u00B7 Verbinde \u00B7 Baue",
    platform: "Plattform",
    findCraft: "Handwerksbetrieb finde",
    submitInquiry: "Projektafrag stelle",
    forCraftBusinesses: "F\u00FCr Handwerksbetrieb",
    aboutUs: "\u00DCber \u00F6is",
    legalAndContact: "R\u00E4chtlichs & Kontakt",
    imprint: "Impressum",
    privacy: "Dat\u00E4schutz",
    accessibility: "Barrierefreiheit",
    contact: "Kontakt",
    copyright: "\u00A9 {{year}} CRAFTFINDUS. F\u00FCr Handwerksbetrieb i de Schwiz, D\u00FCtschland und \u00D6sterrich.",
  },
  cookies: {
    title: "Mir bruuche Cookies",
    description: "Mir bruuche Cookies, damit mir Ine d beschti Erfahrig uf \u00F6isere Website biete ch\u00F6nne. Meh Infos i \u00F6isere",
    privacyLink: "Dat\u00E4schutzerkl\u00E4rig",
    acceptAll: "Alli akzeptiere",
    configure: "Konfiguriere",
    saveSelection: "Uswahl spichere",
    onlyNecessary: "Nur n\u00F6tigi",
    necessary: "N\u00F6tig",
    necessaryDesc: "F\u00FCr de Betrieb vo de Website n\u00F6tig.",
    analytics: "Analyse",
    analyticsDesc: "H\u00E4lfe \u00F6is z verstah, wie d Website bruucht wird.",
    marketing: "Marketing",
    marketingDesc: "Erm\u00F6gliche personalisierti Werbig.",
  },
  mobileCta: {
    submitInquiry: "Projektafrag stelle",
    craftBusiness: "Handwerksbetrieb",
  },
  floatingPhone: {
    question: "H\u00E4nd Sie Frage? R\u00FCefe Sie \u00F6is gern a:",
    ariaLabel: "Telefonnummere azeige",
  },
  home: {
    seoTitle: "Handwerksbetrieb finde & Projektafrage becho",
    seoDesc: "CRAFTFINDUS: Gratis de passend Handwerksbetrieb finde oder als Handwerker qualifizierti Projektafrage becho.",
    heroLabel: "D Handwerker-Plattform f\u00FCr Ihres Projekt",
    heroTitle1: "De richtig",
    heroTitle2: "Handwerker finde.",
    heroTitle3: "Ohni langs Sueche.",
    heroDesc: "Beschriibe Sie Ihres Projekt. Mir finde 3 bis 5 passendi Handwerksbetrieb f\u00FCr Sie. Gratis, i weniger als 24 Stund.",
    heroCta: "Gratis Handwerker finde",
    heroCtaCraft: "Ich bi Handwerksbetrieb",
    badge100Free: "100% gratis",
    badgeResponse: "Antwort i <24h",
    badgeVerified: "Pr\u00FCefti Handwerksbetrieb",
    tradesLabel: "Ihres Projekt, \u00F6ises Netzwerk",
    tradesTitle: "Finde Sie de richtig Handwerker f\u00FCr jedes Gw\u00E4rb",
    tradesDesc: "Egal ob Reparatur, Neubau oder Sanierig \u2013 {{brand}} findet de passend Betrieb bi Ine i de N\u00F6chi.",
    tradesCta: "Jetzt gratis Handwerker finde",
    electrician: "Elektriker",
    electricianDesc: "Elektroinstallation, Beleuchtung, Smart Home \u2013 finde Sie en Elektriker bi Ine i de N\u00F6chi.",
    plumbing: "Sanit\u00E4r & Heizung",
    plumbingDesc: "Bad-Renovierig, Heizungsersatz, Rohrleitige \u2013 professionelli Installateure f\u00FCr Ihres Projekt.",
    roofing: "Dachdecker & Zimmerm\u00E4",
    roofingDesc: "Dachsanierig, Dachf\u00E4nster, Dachstuhl \u2013 erfahreni Dachdecker f\u00FCr sicheri L\u00F6sige.",
    painting: "Maler & Bodenleger",
    paintingDesc: "Fassadeastrich, Tapeziere, Bodebel\u00E4g \u2013 kreativi Handwerker f\u00FCr sch\u00F6ni R\u00E4um.",
    solar: "Photovoltaik & Klima",
    solarDesc: "Solaralage, W\u00E4rmepumpe, Klimaalage \u2013 nachhaltigi Energiel\u00F6sige vom Fachbetrieb.",
    construction: "Bauuntrnehme & Inneausbau",
    constructionDesc: "Trockebau, Flies\u00E4arbeit, Komplettsanierig \u2013 alles us \u00E4inere Hand.",
    howLabel: "3 eifachi Schritt",
    howTitle: "So finde Sie de passend Handwerker",
    howDesc: "Kei langs Sueche. Kei endlosi Telefonat. Mir f\u00FChre Sie dur de Prozess.",
    step1Title: "Projekt beschriibe",
    step1Desc: "Beantworte Sie es paar eifachi Frage \u2013 z.B. 'Bad renoviere' oder 'Solaralag installiere'.",
    step2Title: "Handwerker w\u00E4rde usgw\u00E4hlt",
    step2Desc: "{{brand}} findet dur intelligents Matching automatisch bis zu 5 Handwerksbetrieb, wo zu Ihrem Projekt passe. Us Ihrere Region, mit de richtige Erfahrig.",
    step3Title: "Sie w\u00E4rde kontaktiert",
    step3Desc: "D usgw\u00E4hlte Betrieb m\u00E4lde sich direkt bi Ine, pers\u00F6nlich, nid per Masse-Mail. Sie entscheide, w\u00E4r am beschte passt.",
    benefitsLabel: "Vorteil",
    benefitsTitle: "Ei Plattform, zwei Gwinner",
    forClients: "F\u00FCr Uftragg\u00E4ber",
    clientsTitle: "Handwerker finde: eifach & gratis",
    clientFree: "Komplett gratis",
    clientFreeDesc: "Kei Geb\u00FChre, kei Kommission. Sie zahle nur Ihre Handwerker.",
    clientNoJargon: "Kei Fach-Jargon n\u00F6tig",
    clientNoJargonDesc: "Beschriibe Sie Ihres Projekt mit eigene Wort. Mir finde d richtige Gw\u00E4rb.",
    clientFast: "Schnelli Antworte",
    clientFastDesc: "In weniger als 24 Stund m\u00E4lde sich 3 bis 5 passendi Handwerksbetrieb bi Ine.",
    clientQuality: "Pr\u00FCefti Qualit\u00E4t",
    clientQualityDesc: "Alli Betrieb sind verifiziert. Meisterbetrieb w\u00E4rde bsunders hervorgh\u00E4be.",
    clientCta: "Gratis Afrag stelle",
    forProviders: "F\u00FCr Handwerksbetrieb",
    providersTitle: "Qualifizierti Projektafrage, ohni Ufwand",
    providerMatched: "Passendi Projekt",
    providerMatchedDesc: "Nur Afrage, wo zu Ihrem Gw\u00E4rb, Ihrere Region und Ihre Kapazit\u00E4te passe.",
    providerCompetitors: "Max. 3 bis 5 Mitbewerber",
    providerCompetitorsDesc: "Kei Masseplattform. Fairi Chance dur intelligenti Limiti\u00E4rig.",
    providerTransparent: "Transparenti Choschte",
    providerTransparentDesc: "En f\u00E4schte Priis pro Projektafrag. Kei monatlechi Geb\u00FChre, kei Kommissione.",
    providerRate: "Hohi Annahme-Quote",
    providerRateDesc: "Will s Matching stimmt: hohi Qualit\u00E4t, wenig Streuverlust.",
    providerCta: "Als Handwerksbetrieb registriere",
    principlesTitle: "Warum {{brand}}?",
    principle1Num: "01",
    principle1Title: "Kei Sueche, kei Vergliche",
    principle1Desc: "Mir zeige kei endlosi Liste. \u00D6ise Algorithmus w\u00E4hlt d passende Betrieb f\u00FCr Sie us \u2013 basierend uf Date, nid Zuefall.",
    principle2Num: "02",
    principle2Title: "Qualit\u00E4t statt Masse",
    principle2Desc: "Maximal 3 bis 5 Handwerksbetrieb pro Projekt. So becho Sie echti Ufmerksamkeit, keis Copy-Paste-Agebot.",
    principle3Num: "03",
    principle3Title: "Transparent & fair",
    principle3Desc: "Jede weiss, warum en Match zstand cho isch. Keis Biete, keis Priisdumping. Fairi Bedingige f\u00FCr beidi Site.",
    statsTitle: "{{brand}} i Zahle",
    stat1Value: "3-5",
    stat1Label: "Betrieb pro Projekt",
    stat2Value: "12+",
    stat2Label: "Gw\u00E4rb verf\u00FCegbar",
    stat3Value: "<24h",
    stat3Label: "Reaktionsziit",
    stat4Value: "0 CHF",
    stat4Label: "Choschte f\u00FCr Uftragg\u00E4ber",
    faqLabel: "FAQ",
    faqTitle: "H\u00FCfig gstellti Frage",
    faqDesc: "Antworte f\u00FCr Uftragg\u00E4ber und Handwerksbetrieb.",
    faqForClients: "F\u00FCr Uftragg\u00E4ber",
    faqForProviders: "F\u00FCr Handwerksbetrieb",
    faqC1Q: "Ich bruuch en Handwerker, weiss aber nöd genau weles Gwerb. Isch CRAFTFINDUS s Richtige?",
    faqC1A: "Ja, absolut! CRAFTFINDUS isch genau derfür gmacht. Beschriibe Si eifach Ihres Projekt – mir finde s passende Gwerb und di richtige Betrieb für Sie. Komplett gratis.",
    faqC2Q: "Was choschtet es, wenn ich en Handwerker suech?",
    faqC2A: "Für Sie als Uftraggäber isch CRAFTFINDUS komplett gratis. Sie stelle Ihri Projektafrag, überchöme 3 bis 5 passendi Handwerksbetrieb und entscheide sälber. Kei versteckti Choschte.",
    faqC3Q: "Wie schnäll überchom ich Antworte uf mini Projektafrag?",
    faqC3A: "I de Regle mälde sich qualifizierti Betrieb innerhalb vo 24 Stund. Bi dringende Afrage oft sogar schnäller. Maximal 3 bis 5 Agebot – handverläse.",
    faqC4Q: "Weli Projekt chan ich über CRAFTFINDUS afrage?",
    faqC4A: "Praktisch alli Handwerksprojekt: Elektro, Sanitär, Heizige, Dach, Inneusbuuu, Photovoltaik, Klimaanlage, Malerarbet und no viel meh.",
    faqP1Q: "Was bringt mir CRAFTFINDUS als Handwerksbetrieb?",
    faqP1A: "Sie überchöme vorqualifizierti Projektafrage, wo zu Ihrem Gwerb und Ihrere Region passe. Maximal 3 bis 5 Betrieb pro Afrag – weniger Wettbewerb, höcheri Abschlussquote.",
    faqP2Q: "Wie funktioniert s Matching bi CRAFTFINDUS?",
    faqP2A: "Üse Algorithmus analysiert jedi Projektafrag und gliicht sie mit Ihrem Profil ab: Gwerb, Spezialisierig, Region, Verfüegbarkeit und Projektgröössi.",
    faqP3Q: "Was choschtet CRAFTFINDUS für Handwerksbetrieb?",
    faqP3A: "Sie zahle nur pro agnommene Projektafrag en transparänte, feschte Priis. Kei monatlechi Gebühre, kei Provisione.",
    faqP4Q: "Was underscheidet CRAFTFINDUS vo andere Handwerker-Portal?",
    faqP4A: "Keis Biete, keis Priisdumping. Bi CRAFTFINDUS wärde Betrieb usgwählt, nöd gsuecht. D Limitierig uf 3 bis 5 Betrieb pro Afrag sicheret fairi Chance.",
    ctaLabel: "Jetzt starte",
    ctaTitle: "Was trifft uf Sie zue?",
    ctaClientTitle: "Ich sueche en Handwerker",
    ctaClientDesc: "Beschriibe Sie Ihres Projekt. Mir finde gratis d passende Handwerksbetrieb f\u00FCr Sie.",
    ctaClientBtn: "Gratis Afrag stelle",
    ctaProviderTitle: "Ich bi Handwerksbetrieb",
    ctaProviderDesc: "Becho Sie vorqualifizierti Projektafrage, wo zu Ihrem Profil passe. Ohni Biete, ohni Priiskampf.",
    ctaProviderBtn: "Jetzt registriere",
  },
  auth: {
    seoTitle: "Anm\u00E4lde \u2013 Handwerksbetrieb Portal",
    seoDesc: "M\u00E4lde Sie sich bi CRAFTFINDUS a \u2013 em exklusive Portal f\u00FCr qualifizierti Handwerksbetrieb.",
    backToHome: "Zrugg zur Startsyte",
    loginPrompt: "M\u00E4lde Sie sich i Ihrem Account a",
    emailLabel: "E-Mail",
    emailPlaceholder: "ihri@email.ch",
    passwordLabel: "Passwort",
    passwordPlaceholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
    loginBtn: "Anm\u00E4lde",
    invalidCredentials: "Ung\u00FCltige Zugangsd\u00E4te. Bitte pr\u00FCefe Sie Ihri Iigabe.",
    alreadyRegistered: "Die E-Mail-Adresse isch scho registriert.",
    registrationSuccess: "Registrierig erfolgrich! Bitte best\u00E4tige Sie Ihri E-Mail.",
    loginSuccess: "Erfolgrich agm\u00E4ldet",
    invalidEmail: "Bitte g\u00E4be Sie en g\u00FCltige E-Mail-Adresse ii",
    passwordMin: "Passwort mues mindestens 6 Zeiche ha",
  },
  dashboard: {
    title: "Projektafrage",
    subtitle: "Qualifizierti Projektafrage f\u00FCr Ihre Betrieb",
    tabNew: "Neu",
    tabInReview: "I Pr\u00FCefig",
    tabCompleted: "Abgschlosse",
    tabPayment: "Zahlig & Abr\u00E4chig",
    tabProfile: "Profil",
    noNew: "Kei neui Projektafrage",
    noInReview: "Kei laufendi Projektafrage",
    noCompleted: "Kei abgschlosseni Projektafrage",
    selectForDetails: "W\u00E4hle Sie en Projektafrag\nf\u00FCr Details",
    weeklyLimitReached: "Wuchelimit erreicht",
    paymentMissing: "Zahligsmittel f\u00E4hlt",
    paymentMissingDesc: "Projektafrage w\u00E4rde erst nach Hinterlegig freigschaltet.",
    setupPayment: "Jetzt hinterlege \u2192",
    paymentRequired: "Bitte zersch es Zahligsmittel hinterlege",
    subscriptionBlocked: "Abo gsperrt \u2013 bitte Zahlig under Abr\u00E4chig abschliesse",
    quotaExhausted: "Kontingent erreicht \u2013 Add-on chaufe oder Plan upgrade",
    acceptError: "F\u00E4hler bim Anneh",
    accepted: "Projektafrag agnoh",
    declined: "Projektafrag abglehnt",
    declineError: "F\u00E4hler bim Ablehne",
    questionSent: "R\u00FCckfrag gschickt",
    completed: "Projektafrag abgschlosse",
    completeError: "F\u00E4hler bim Abschliesse",
  },
  onboarding: {
    progressCompany: "Betrieb",
    progressTradesRegion: "Gw\u00E4rb & Region",
    progressConfig: "Konfiguration",
    companyTitle: "Ihre Betrieb",
    companySubtitle: "Grundlegendi Info f\u00FCr Ihres Profil",
    companyName: "Betriebsname",
    companyNamePlaceholder: "Ihre Handwerksbetrieb",
    contactPerson: "Asprächpartner",
    contactPersonPlaceholder: "Max Muster",
    masterCraftsman: "Meisterbetrieb",
    masterCraftsmanDesc: "Ihre Betrieb isch en iitragnige Meisterbetrieb",
    tradesTitle: "Ihri Gw\u00E4rb",
    tradesSubtitle: "W\u00E4lchi Gw\u00E4rb decke Sie ab?",
    regionTitle: "Ihre Standort",
    regionSubtitle: "Wo isch Ihre Betrieb?",
    regionLabel: "Region / PLZ",
    regionPlaceholder: "z.B. Z\u00FCri, 8001",
    radiusTitle: "Iisatzradius",
    radiusSubtitle: "Wie wiit fahre Sie zu Chunde?",
    limitTitle: "Projektafrage-Limit",
    limitSubtitle: "Wie viel Afrage w\u00E4nde Sie pro Wuche becho?",
    limitFocused: "Fokussiert",
    limitStandard: "Standard",
    limitIntensive: "Intensiv",
    completeTitle: "Betriebsprofil spichere",
    summaryCompany: "Betrieb",
    summaryTrades: "Gw\u00E4rb",
    summaryMaster: "Meisterbetrieb",
    summaryRadius: "Iisatzradius",
    summaryLimit: "Limit",
    summaryPerWeek: "pro Wuche",
    saveProfile: "Betriebsprofil spichere",
    saving: "Wird gspichered...",
    profileCreated: "Betriebsprofil erstellt",
    saveError: "F\u00E4hler bim Spichere",
    veryNear: "Sehr n\u00F6ch",
    nearCity: "Stadtn\u00F6ch",
    regional: "Regional",
    wide: "Witr\u00E4umig",
    superRegional: "\u00DCberregional",
  },
  inquiry: {
    seoTitle: "Projektafrag stelle \u2013 Qualifizierti Handwerksbetrieb finde",
    seoDesc: "Projektafrag stelle bi CRAFTFINDUS: Beschriibe Sie Ihres Projekt und mir finde bis zu 5 qualifizierti Handwerksbetrieb us Ihrere Region.",
    tradeElektriker: "Elektriker",
    tradeSanitaer: "Sanitär",
    tradeHeizung: "Heizige",
    tradeDachdecker: "Dachdecker",
    tradeInnenausbau: "Inneusbuuu",
    tradeSchreiner: "Schriiner",
    tradeBauunternehmen: "Buuunternähme",
    tradeFensterbauer: "Fänschterbauer",
    tradeGartenbau: "Gartebuuu",
    tradePhotovoltaik: "Photovoltaik",
    tradeKlimaanlagen: "Klimaanlage",
    tradeMalerbetrieb: "Maler",
    progressDetails: "Projektdetails",
    progressDescription: "Beschriibig",
    progressContact: "Kontakt",
    questionOf: "Frag {{current}} vo {{total}}",
    tradeTitle: "W\u00E4lchs Gw\u00E4rb bruuche Sie?",
    tradeSubtitle: "W\u00E4hle Sie s passende Gw\u00E4rb",
    tradesLoading: "Gw\u00E4rb w\u00E4rde glade...",
    projectTypeTitle: "Art vom Projekt",
    projectTypeSubtitle: "Was soll gmacht w\u00E4rde?",
    repair: "Reparatur",
    repairDesc: "Bestehendi Sch\u00E4de behebe",
    newBuild: "Neubau",
    newBuildDesc: "Neus Geb\u00E4ud oder Abau",
    renovation: "Sanierig",
    renovationDesc: "Bestehendes renoviere",
    installation: "Installation",
    installationDesc: "Neui Alag oder System iibaue",
    objectTypeTitle: "Art vom Objekt",
    objectTypeSubtitle: "Um was f\u00FCr es Geb\u00E4ud gaht's?",
    efh: "Eifamiliehuus",
    mfh: "Mehrfamiliehuus",
    commercial: "Gw\u00E4rb / B\u00FCro",
    industrial: "Industrie",
    publicBuilding: "\u00D6ffentlichs Geb\u00E4ud",
    urgencyTitle: "Wie dringend isch Ihres Projekt?",
    urgencySubtitle: "Ziitrahme f\u00FCr de Start",
    immediate: "Sofort",
    immediateDesc: "So schnell wie m\u00F6glich",
    oneWeek: "1 Wuche",
    oneWeekDesc: "Innerhalb vo de n\u00F6chste 7 T\u00E4g",
    oneMonth: "1 Monet",
    oneMonthDesc: "Innerhalb vo de n\u00F6chste 30 T\u00E4g",
    flexible: "Flexibel",
    flexibleDesc: "Kei f\u00E4schte Ziitrahme",
    budgetTitle: "Gsch\u00E4tzts Budget",
    budgetSubtitle: "Hilft bi de Zueornig",
    under2k: "Under 2'000 CHF",
    budget2k10k: "2'000 bis 10'000 CHF",
    budget10k50k: "10'000 bis 50'000 CHF",
    over50k: "\u00DCber 50'000 CHF",
    budgetUnclear: "No unklar",
    descriptionTitle: "Beschriibe Sie Ihres Projekt",
    descriptionSubtitle: "Max. 5'000 Zeiche",
    descriptionPlaceholder: "Was soll gmacht w\u00E4rde? G\u00E4nd's Bsunderheite?",
    desiredStart: "Gw\u00FCnschte Starttermin (optional)",
    locationTitle: "Wo isch s Projekt?",
    locationSubtitle: "PLZ oder Ort iigee",
    contactTitle: "Ihri Kontaktd\u00E4te",
    contactSubtitle: "F\u00FCr d Kontaktufnahm dur qualifizierti Handwerksbetrieb",
    contactNameLabel: "Name *",
    contactNamePlaceholder: "Ihre Name",
    contactEmailLabel: "E-Mail *",
    contactPhoneLabel: "Telefon *",
    contactPhonePlaceholder: "+41 ...",
    toSummary: "Witer zur \u00DCbersicht",
    commitTitle: "\u00DCbergab a bis zu 5 qualifizierti Handwerksbetrieb",
    commitDesc: "Ihri Afrag wird direkt a passendi Betrieb i Ihrere Region witergleitet.",
    summaryTrade: "Gw\u00E4rb",
    summaryProjectType: "Projektart",
    summaryUrgency: "Dringli",
    summaryLocation: "Standort",
    summaryBudget: "Budget",
    submitInquiry: "Projektafrag abschicke",
    submitting: "Wird \u00FCbermittlet...",
    submitSuccess: "Projektafrag erfolgrich \u00FCberge",
    submitError: "F\u00E4hler bim Schicke vo de Afrag",
  },
  thankyou: {
    inquiryTitle: "Ihri Projektafrag isch bi \u00F6is igange",
    inquiryDesc: "Mir gliche Ihres Projekt jetzt mit \u00F6isem Netzwerk vo qualifizierte Handwerksbetrieb ab.",
    nextStepsTitle: "So gaht's witer",
    inquiryStep1: "Mir pr\u00FCefe Ihri Afrag und finde bis zu 5 passendi Handwerksbetrieb.",
    inquiryStep2: "Sie becho Kontaktvorschl\u00E4g per E-Mail \u2013 i de Regle innerhalb vo 24 Stund.",
    inquiryStep3: "Sie entscheide frei, mit w\u00E4lem Betrieb Sie ins Gspr\u00E4ch g\u00F6nd.",
    urgentContact: "Bi dringende R\u00FCckfrage erreiche Sie \u00F6is under",
    registrationTitle: "Registrierig igange!",
    registrationDesc: "Vielen Dank f\u00FCr Ihres Interessi a CRAFTFINDUS. Mir h\u00E4nd Ihri Registrierig erhalte.",
    registrationStep1: "\u00D6ises Team pr\u00FCeft Ihri Agabe sorgf\u00E4ltig.",
    registrationStep2: "Nach erfolgricher Pr\u00FCefig becho Sie Ihri Zugangsd\u00E4te per E-Mail.",
    registrationStep3: "Sie ch\u00F6nne sich denn anm\u00E4lde und sofort qualifizierti Projektafrage empfange.",
    reviewTime: "D Pr\u00FCefig duuret i de Regle 1\u20132 W\u00E4rchtig.",
    contactTitle: "Vielen Dank f\u00FCr Ihri Nachricht",
    contactDesc: "Mir h\u00E4nd Ihri Afrag erhalte und m\u00E4lde \u00F6is schnellstm\u00F6glich bi Ine.",
    contactResponse: "I de Regle antworte mir innerhalb vo 24 Stund a W\u00E4rchtig. Bi dringende Aliege erreiche Sie \u00F6is au telefonisch under",
    sendAnother: "Witeri Nachricht schicke",
  },
  contact: {
    seoTitle: "Kontakt \u2013 CRAFTFINDUS erreiche",
    seoDesc: "Kontaktiere Sie CRAFTFINDUS: Frage zu Projektafrage, Registrierig oder Partnerschaft?",
    title: "Kontakt",
    desc: "H\u00E4nd Sie Frage zu {{brand}} oder w\u00E4nde Sie \u00F6is direkt erreiche? Mir freue \u00F6is uf Ihri Nachricht.",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    nameLabel: "Name *",
    namePlaceholder: "Ihre Name",
    emailFieldLabel: "E-Mail *",
    emailPlaceholder: "ihri@email.ch",
    subjectLabel: "Betreff *",
    subjectPlaceholder: "Worum gaht's?",
    messageLabel: "Nachricht *",
    messagePlaceholder: "Ihri Nachricht a \u00F6is...",
    sendBtn: "Nachricht schicke",
    sending: "Wird gschickt...",
    sent: "Nachricht gschickt!",
    sendFailed: "Versand fehlgschlage. Bitte versuche Sie's sp\u00E4ter nomal.",
    nameRequired: "Bitte g\u00E4be Sie Ihre Name ii",
    emailRequired: "Bitte g\u00E4be Sie en g\u00FCltige E-Mail-Adresse ii",
    subjectRequired: "Bitte g\u00E4be Sie en Betreff ii",
    messageMin: "Nachricht mues mindestens 10 Zeiche ha",
  },
  about: {
    seoTitle: "\u00DCber CRAFTFINDUS \u2013 Handwerker-Vermittlig fair & intelligent",
    seoDesc: "CRAFTFINDUS verbindet Uftragg\u00E4ber mit qualifizierte Handwerksbetrieb im DACH-Ruum.",
    heroLabel: "\u00DCber {{brand}}",
    heroTitle1: "D M\u00E4nsche hinter",
    heroTitle2: "CRAFTFINDUS.",
    heroDesc: "{{brand}} isch us enere eifache Beobachtig entstande: Uftragg\u00E4ber finde schwer de richtig Handwerksbetrieb. Und gueti Handwerker verbr\u00E4nde z viel Ziit mit Akquise.",
    teamLabel: "\u00D6ises Team",
    teamTitle: "D M\u00E4nsche hinter",
    founderRole: "Gr\u00FCnder",
    founderBio1: "Als Unternehmer us Solige kenne ich beidi Site: D Frustration vo Uftragg\u00E4ber und d Herausforderig f\u00FCr Handwerksbetrieb.",
    founderBio2: "{{brand}} isch mini Antwort uf das Problem. En Plattform, wo uf intelligents, fairs Matching setzt.",
    chrisRole: "Gsch\u00E4ftspartner",
    chrisBio: "Chris bringt strategischs Denke und unternehmerischi Erfahrig is Team. Er tribt d Witerentwicklig vo {{brand}} vora.",
    veronikaRole: "Assistenz vo de Gsch\u00E4ftsleitig & Backoffice",
    veronikaBio: "Veronika haltet im Hintergrund alli F\u00E4de zeme. Sie sorgt d\u00E4f\u00FCr, dass Prozess reibigslos laufe.",
    dukeRole: "B\u00FCrehumd & Feel-Good-Manager",
    dukeBio: "Keis Meeting ohni Duke. \u00D6ise Bull Terrier sorgt f\u00FCr gueti Luune und erinnert \u00F6is a Pause.",
    valuesLabel: "\u00D6iseri W\u00E4rt",
    valuesTitle: "Wof\u00FCr mir st\u00F6nd",
    value1Title: "Qualit\u00E4t vor Quantit\u00E4t",
    value1Desc: "Mir gl\u00F6ube a wenigi, d\u00E4f\u00FCr passendi Verbindige. Jedi Afrag wird uf 3 bis 5 Betrieb limitiert.",
    value2Title: "Fairness f\u00FCr beidi Site",
    value2Desc: "Gratis f\u00FCr Uftragg\u00E4ber, transparenti Fixpriis f\u00FCr Handwerksbetrieb.",
    value3Title: "Eifachheit",
    value3Desc: "Handwerk isch komplex gnueg. Mir mache de Weg zum passende Betrieb so eifach wie m\u00F6glich.",
    missionLabel: "\u00D6iseri Mission",
    missionTitle: "Handwerker-Vermittlig, wie si si soll",
    missionP1: "De Handwerksmert isch fragmentiert. Tusigi Betrieb, unz\u00E4hligi Portaal, aber chuum echti Orientierig.",
    missionP2: "{{brand}} machts anders: Mir w\u00E4hle f\u00FCr jedi Afrag gezielt 3 bis 5 passendi Betrieb us.",
    missionP3: "\u00D6ises Ziel: D erschti Alaufstell im DACH-Ruum f\u00FCr Uftragg\u00E4ber.",
    ctaTitle: "Bereit, \u00F6is kenne z lerne?",
    ctaDesc: "Ob Sie en Handwerksbetrieb sueche oder als Handwerker qualifizierti Projektafrage w\u00E4nde: Mir freue \u00F6is uf Sie.",
    ctaInquiry: "Projektafrag stelle",
    ctaContact: "Kontakt ufneh",
  },
  pricing: {
    seoTitle: "Priise \u2013 Abo-Pl\u00E4n f\u00FCr Handwerksbetrieb",
    seoDesc: "Transparenti Monatpl\u00E4n f\u00FCr qualifizierti Projektafrage.",
    heroLabel: "Priise",
    heroTitle1: "Meh Auftr\u00E4g.",
    heroTitle2: "Weniger Leerlauf.",
    heroDesc: "W\u00E4hle Sie de Plan, wo zu Ihrem Betrieb passt.",
    leadsIncluded: "agnohni Leads inklusive",
    choosePlan: "Plan w\u00E4hle",
    mostPopular: "Beliebteste Plan",
    addonsLabel: "Add-ons",
    addonsTitle: "Zusätzlichi Leads bueche",
    radiusLabel: "Radius-Erwiiterige",
    radiusTitle: "Iisatzgebiet erwiitere",
    radiusDesc: "Erwiitere Sie Ihre Iisatzradius und becho Sie Projektafrage us emne grössere Gebiet.",
    trustNoContract: "Kei Vertragsbindig",
    landingLabel: "Priise für Handwerksbetrieb",
    landingTitle: "Transparenti Abo-Plän",
    landingDesc: "Wähle Sie de Plan, wo zu Ihrem Betrieb passt – kei versteckti Choschte, kei Vertragsbindig.",
    landingCta: "Alli Plän aaluege",
    trustInstant: "Sofort startklar",
    trustVerified: "Nur pr\u00FCefti Afrage",
    faqLabel: "H\u00FCfigi Frage",
    faqTitle: "Frage zu de Priise",
    ctaTitle: "Bereit f\u00FCr neui Auftr\u00E4g?",
    ctaDesc: "Registriere Sie sich gratis, w\u00E4hle Sie Ihre Plan und becho Sie passendi Projektafrage.",
    ctaBtn: "Jetzt registriere",
    faq1q: "Zahli ich nur bi Annahm?",
    faq1a: "Nei \u2013 mit emne Abo-Plan zahle Sie en f\u00E4schte Monetsbetrag.",
    faq2q: "Was passiert, weni mis Kontingent ufbruche?",
    faq2a: "Wenn Ihri inkludierte Leads uf sind, ch\u00F6nne Sie es Add-on chaufe.",
    faq3q: "Chani de Plan jederziit wechsle?",
    faq3a: "Ja, Sie ch\u00F6nne jederziit upgrade. De neui Plan wird sofort aktiv.",
    faq4q: "G\u00E4nd's en Vertragsbindig?",
    faq4a: "Nei. Sie ch\u00F6nne Ihres Abo jederziit zum End vo de laufende Periode ch\u00FCndige.",
    faq5q: "Was isch im 'Premium'-Plan bsunders?",
    faq5a: "Premium-Betrieb becho es Verifiziert-Badge und w\u00E4rde bi de Zustellig priorisiert.",
  },
  billing: {
    title: "Abr\u00E4chig & Plan",
    subtitle: "Verwalte Sie Ihre Plan, Kontingent und Zahlingsmethode",
    tabPlan: "Plan & Abr\u00E4chig",
    tabQuotas: "Kontingent",
    tabPayment: "Zahlingsmethode",
    statusActive: "Aktiv",
    statusTrial: "Testphas",
    statusPastDue: "Zahlig usstehend",
    statusBlocked: "Gsperrt",
    statusCanceled: "Gch\u00FCndigt",
    statusPending: "Usstehend",
    pastDueBanner: "Zahlig fehlgschlage. Bitte aktualisiere Sie Ihri Zahlingsmethode.",
    blockedBanner: "Abo gsperrt. Bitte schliesse Sie d Zahlig ab.",
    updatePayment: "Zahlingsmethode aktualisiere",
    cancelledNotice: "Ihres Abo endet am {{date}}.",
    cancelSub: "Abo ch\u00FCndige",
    cancelConfirm: "W\u00E4nde Sie Ihres Abo w\u00FCrkli zum Periodened ch\u00FCndige?",
    cancelSuccess: "Abo wird zum Periodened gch\u00FCndigt",
    noPlan: "Kein aktive Plan",
    noPlanDesc: "W\u00E4hle Sie en Plan, um qualifizierti Projektafrage z becho.",
    changePlan: "Plan wechsle",
    selectPlan: "Plan w\u00E4hle",
    currentPlan: "Aktuell",
    activePlan: "Aktive Plan",
    leadsIncl: "Leads inkl.",
    addonsTitle: "Add-ons",
    buy: "Chaufe",
    acceptedLeads: "Agnohni Leads",
    deliveries: "Zustellige",
    quotaReached: "Kontingent erreicht \u2013 Add-on chaufe oder Plan upgrade",
    billingPeriod: "Abr\u00E4chigszitruum",
    periodResets: "Kontingent w\u00E4rde automatisch zum Periodebeginn zrugggsetzt.",
  },
  registration: {
    seoTitle: "Handwerksbetrieb registriere \u2013 Qualifizierti Projektafrage becho",
    seoDesc: "Als Handwerksbetrieb bi CRAFTFINDUS registriere: I 15 Minute startklar.",
    title: "Als Handwerksbetrieb registriere",
    subtitle: "F\u00FClle Sie s Formular us. Nach Pr\u00FCefig becho Sie Ihri Zugangsd\u00E4te per E-Mail.",
    requiredFields: "Pflichtf\u00E4lder: Betriebsname, Kontaktperson, E-Mail",
    fillRequired: "Bitte f\u00FClle Sie Betriebsname, Kontaktperson und E-Mail us.",
    submitting: "Wird gschickt...",
    submitBtn: "Registrierig abschicke",
    submitError: "F\u00E4hler bim Abschicke",
  },
  handwerker: {
    seoTitle: "Chunde gwinne \u2013 Qualifizierti Projektafrage ohni Chaltakquise",
    seoDesc: "Chunde gwinne ohni Chaltakquise: CRAFTFINDUS liefert vorqualifizierti Projektafrage passend zu Ihrem Gw\u00E4rb.",
    heroLabel: "F\u00FCr Handwerksbetrieb & Meisterbetrieb",
    heroTitle1: "Qualifizierti Projektafrage.",
    heroTitle2: "Kei Priiskampf.",
    heroDesc: "{{brand}} liefert Ine vorqualifizierti Projektafrage vo Chunde, wo jetzt en Handwerker bruuche.",
    registerFree: "Jetzt gratis registriere",
    badgeNoContract: "Kei Vertragsbindig",
    badgeReady: "I 15 Min. startklar",
    badgeVerified: "Nur pr\u00FCefti Afrage",
    badgePayOnAccept: "Zahlig nur bi agnohmem Projekt",
    benefitsLabel: "Ihri Vorteil",
    benefitsTitle: "Warum Handwerksbetrieb {{brand}} w\u00E4hle",
    benefit1Title: "Passgenau gematcht",
    benefit1Desc: "\u00D6ise Algorithmus glichet jedi Afrag mit Ihrem Profil ab.",
    benefit2Title: "Max. 3 bis 5 Betrieb pro Projekt",
    benefit2Desc: "Kei Masseverteiler. Weniger Wettbewerb, h\u00F6cheri Abschlussquote.",
    benefit3Title: "Transparenti Fixpriis",
    benefit3Desc: "Sie zahle nur pro agnohnere Afrag \u2013 en f\u00E4schte, transparente Priis.",
    benefit4Title: "Vorqualifizierti Afrage",
    benefit4Desc: "Jedi Projektafrag wird pr\u00FCeft, bevor si a Sie witergleitet wird.",
    benefit5Title: "Planbars Wachstum",
    benefit5Desc: "Bestimme Sie flexibel, wie viel Afrage Sie pro Monet annehme.",
    benefit6Title: "Schnelle Zugang",
    benefit6Desc: "Registriere, Profil alege, erschti Afrage becho. I weniger als 15 Minute startklar.",
    pricingLabel: "Priisbiispiel",
    pricingTitle: "Transparenti Fixpriis pro Projektafrag",
    pricingDesc: "Sie zahle nur f\u00FCr Afrage, wo Sie aktiv annehme.",
    smallProjects: "Chliprojekt",
    smallExamples: "z.B. Steckdose setze, Wasserhahn repariere, Wand striiche",
    mediumProjects: "Mittleri & grossi Projekt",
    mediumExamples: "z.B. Bad-Renovierig, Heizungsersatz, PV-Alag, Dachsanierig",
    priceFrom: "ab {{price}} CHF",
    perAcceptedInquiry: "pro agnohnere Projektafrag",
    goodToKnow: "Guet z wisse",
    goodToKnow1: "Kei monatlechi Geb\u00FChre. Sie zahle nur bi Annahm",
    goodToKnow2: "Projektgr\u00F6ssi bestimmt de Priis \u2013 vorab transparent sichtbar",
    goodToKnow3: "Reklamation bi Fehlqualifizierig \u2013 Erstattig garantiert",
    goodToKnow4: "Abr\u00E4chig \u00FCber Ihri hinterlegti Zahlingsmethode",
    howLabel: "So funktioniert's",
    howTitle: "I 3 Schritt zu neue Projekt",
    step1Title: "Profil alege",
    step1Desc: "Gw\u00E4rb, Region, Kapazit\u00E4t und Spezialisierig agee.",
    step2Title: "Projektafrage becho",
    step2Desc: "Passendi Projekt w\u00E4rde Ine automatisch zuegstellt.",
    step3Title: "Anneh & kontaktiere",
    step3Desc: "Sie entscheide, w\u00E4lchi Projekt Sie annehme und spreche direkt mit em Chund.",
    startNow: "Jetzt starte",
    faqLabel: "H\u00FCfigi Frage",
    faqTitle: "Frage vo Handwerksbetrieb",
    ctaTitle: "Bereit f\u00FCr qualifizierti Projektafrage?",
    ctaDesc: "Registriere Sie sich gratis und becho Sie passendi Projekt \u2013 ohni Vertragsbindig.",
    ctaBtn: "Gratis registriere",
  },
  notFound: {
    title: "Syte nid gfunde",
    description: "Die agforderet Syte existiert nid.",
  },
  limitReached: {
    title: "Pause",
    subtitle: "Ihres Wuchelimit isch erreicht.",
    nextReset: "N\u00F6chsti Freischaltig",
    description: "S Limit sch\u00FCtzt d Qualit\u00E4t vo de Plattform.",
    adjustLimit: "Limit apasse",
  },
  completionDialog: {
    confirmTitle: "Afrag abschliesse",
    confirmDesc: "Isch d Afrag abgschlosse und de Kontakt zum Chund beendet?",
    confirmYes: "Ja, abschliesse",
    confirmNo: "Nei, zrugg",
    outcomeTitle: "Ergebnis",
    outcomeDesc: "Isch en Uftrag zstand cho?",
    won: "Ja – Uftrag gwunne",
    lost: "Nei – Uftrag verlore",
    noFit: "Kei Fit / Nid witerverfolgt",
  },
  aiSearch: {
    title: "Was isch CRAFTFINDUS?",
    definition: "CRAFTFINDUS isch e digitali Qualitätsplattform für d Vermittlig vo prüefte Handwerksbetrieb i de Schwiiz, Dütschland, Öschtrych, de Niederlande, Belgie, Frankriich und Pole. Uftragsgeber beschriibe ihres Projäkt – CRAFTFINDUS findet durch intelligents Matching 3 bis 5 passendi, verifizierti Fachbetrieb us de Region. De Service isch für Uftragsgeber gratis und unverbindlich. Handwerksbetrieb zahle en transparänte Fixpriis pro aagnomme Kontakt – ohni Provisione, ohni Vertragsbiindig.",
    highlight1: "Prüefti Betrieb: Gewerbeanmeldig, Versicherig, Bonität verifiziert",
    highlight2: "Max. 3–5 Betrieb pro Projäkt: Fairi Chance, kei Priiskampf",
    highlight3: "Transparänti Priise: Feschti Kontaktpriise, kei versteckti Gebühre",
    highlight4: "Faire Reklamationsprozäss: Erstattig bi unqualifizierte Kontäkt",
  },
  seoLanding: {
    verified: "Prüefti Betrieb",
    free: "Gratis & unverbindlich",
    fast: "Antwort i 24h",
    ctaRequest: "Jetzt Afrag stelle",
    freeForClients: "Gratis für Uftraggäber",
    whatIsCraftfindus: "Was isch CRAFTFINDUS?",
    whatIsCraftfindusText: "CRAFTFINDUS isch e digitali Plattform zur Vermittig vo prüefte Handwerksbetrieb i de Schwiz, Dütschland, Österrich, Belgie, Holland, Frankrich und Pole. Sie beschriibe Ihres Projekt – mir finde 3 bis 5 passendi Fachbetrieb bi Ine i de Nöchi. Gratis und unverbindlich.",
    verifiedProviders: "Prüefti {{trade}} i {{city}}",
    howItWorks: "So funktioniert CRAFTFINDUS",
    costs: "{{trade}} Choschte & Priise",
    inCity: "i {{city}}",
    faq: "Hüfig gstellti Frage",
    ctaHeading: "{{trade}} i {{city}} gsuecht?",
    ctaSubtext: "Stelle Sie jetzt Ihri gratisi Afrag und überchöme Sie bis zu 5 Offerte vo prüefte Betrieb.",
    relatedCities: "{{trade}} i wiitere Stedt",
    otherTrades: "Witeri Gwärb i {{city}}",
    relatedArticles: "Passendi Ratgäber-Artikel",
  },
  blog: {
    title: "CRAFTFINDUS Ratgäber",
    description: "Tipps, Choschte und Ratgäber rund um Handwerksprojekt",
    noPosts: "No kei Biträäg vorhande.",
    backToList: "Zrugg zum Ratgäber",
  },
  warum: {
    seoTitle: "Warum CRAFTFINDUS – D Qualitätsplattform für Handwerksvermittig",
    seoDesc: "Erfahre Sie, warum CRAFTFINDUS anders isch: Lead-Qualitätsprüefig, transparenti Priise, verifizierti Betrieb und faire Reklamationsprozess.",
    heroLabel: "Warum CRAFTFINDUS",
    heroTitle1: "Handwerksvermittig,",
    heroTitle2: "wie si si sött.",
    heroDesc: "Di meiste Plattforme verteile Kontakt. Mir vermittle qualifizierti Projekt a prüefti Betrieb – fair, transparent und outcome-optimiert.",
    problemLabel: "S Marktproblem",
    problemTitle: "Was bi andere Plattforme schieflouft",
    problem1Title: "Unqualifizierti Afrage",
    problem1Desc: "Kontakt ohni Budget, ohni ächts Projekt, ohni verifizierti Date. Sie zahle für Leads, wo nie zu Ufträg wärde.",
    problem2Title: "Intransparenti Choschte",
    problem2Desc: "Versteckti Gebühre, Provisione uf Ufträg, unklari Priismodell.",
    problem3Title: "Masseverteilig",
    problem3Desc: "Ihri Afrag gaht a 10, 15 oder 20 Betrieb gliichzitig. S Ergebnis: Priiskampf, Copy-Paste-Offerte, Frust.",
    problem4Title: "Keis Reklamationsrächt",
    problem4Desc: "Kontakt nid erreichbar? Falschs Gwärb? Pech gha. Bi de meiste Plattforme gits kei fairi Lösig.",
    solutionLabel: "Üse Ansatz",
    solutionTitle: "Was CRAFTFINDUS anders macht",
    solution1Title: "Lead-Qualitätsscore",
    solution1Desc: "Jedi Afrag wird automatisch bewertet: Telefon verifiziert, Budget angee, Beschriibig vorhande. Nur Afrage mit Score > 60 wärde abgrächnet.",
    solution2Title: "Transparenti Kontaktpriise",
    solution2Desc: "Feschti Priise pro Kontakt – vorab sichtbar. Kei Provisione, kei versteckti Gebühre.",
    solution3Title: "Max. 3-5 Betrieb pro Projekt",
    solution3Desc: "Jedi Afrag gaht a maximal 5 prüefti Betrieb. Weniger Wettbewerb, höcheri Abschlussquote.",
    solution4Title: "Faire Reklamationsprozess",
    solution4Desc: "Kontakt nid erreichbar? Falschs Gwärb? Sie überchöme Ihre Kontaktpriis zrugg – innerhalb vo 72 Stund, garantiert.",
    solution5Title: "Verifizierti Betrieb",
    solution5Desc: "Gewerbeanmäldig, Versicherig, Bonität – üsi Betrieb durchloufe en mehrstufige Verifizierigsprozess.",
    solution6Title: "Fairness-Mechanismus",
    solution6Desc: "Automatischi Missbruchserkennig, Transparenz-Dashboard und maximali Reklamationsquote schütze d Plattformqualität.",
    ctaTitle: "Überzüügt?",
    ctaClientBtn: "Projekt professionell starte",
    ctaProviderBtn: "Meh qualifizierti Projekt sichre",
  },
  inquiryPsych: {
    qualityHint: "Je gnauer Ihri Agabe, desto besser d Betrieb wo Sie überchöme.",
    timePromise: "Duuret weniger als 2 Minute",
    matchingHint: "Mir prüefe Ihri Afrag, bevor si a passendi Fachbetrieb witergleitet wird.",
    descShort: "Bitte beschriibe Sie Ihres Projekt öppis usführlicher.",
    descGood: "Sehr gueti Beschriibig – das erhöht Ihri Chance uf schnelli Offerte.",
    photoHint: "Fotos hälfe bi ere präzise Iischätzig.",
  },
  quality: {
    seoTitle: "Qualitätsversprächä – So funktioniert CRAFTFINDUS",
    seoDesc: "Erfahre Sie transparent, wie mir Projekt prüefe, Betrieb verifiziere, fair abgrächne und Reklamatione bearbeite.",
    heroLabel: "Üses Qualitätsversprächä",
    heroTitle1: "Transparänz.",
    heroTitle2: "Nid nur es Versprächä.",
    heroDesc: "Mir erkläre Ine gnau, wie üsi Plattform funktioniert – vo de Projektprüefig bis zur Reklamation.",
    sec1Title: "Wie Projekt prüeft wärde",
    sec1Desc: "Jedi Afrag durchlouft üsi automatischi Qualitäts-Engine. Nur Afrage mit emne Score vo mindestens 60 Punkt wärde a Betrieb witergleitet.",
    sec1Item1: "Telefonnummere wird verifiziert (+20 Punkt)",
    sec1Item2: "Budgetangab vorhande (+25 Punkt)",
    sec1Item3: "Projektbeschriibig prüeft (+10 Punkt)",
    sec1Item4: "Kontaktdate vollständig (+10 Punkt)",
    sec2Title: "Wie Betrieb verifiziert wärde",
    sec2Desc: "Üsi Betrieb durchloufe en mehrstufige Verifizierigsprozess. Nur prüefti Betrieb überchöme Projektafrage.",
    sec2Item1: "Gewerbeanmäldig prüeft (Level 1)",
    sec2Item2: "Betriebshaftpflicht verifiziert (Level 2)",
    sec2Item3: "Bonitätsprüefig bestande (Level 3)",
    sec2Item4: "Identitätsprüefig abgschlosse (Level 3)",
    sec3Title: "Wie Abgrächnig funktioniert",
    sec3Desc: "Transparenti, planbari Choschte. Kei versteckti Gebühre, kei Provisione uf Ufträg.",
    sec3Item1: "Feschti Priise pro Kontakt – vorab sichtbar",
    sec3Item2: "Flexibli Modell: Flex, Professional, Premium",
    sec3Item3: "Monatlechi Abgrächnig, jederziit kündbar",
    sec4Title: "Wie Reklamation funktioniert",
    sec4Desc: "Faire Prozess bi berechtigte Beschwerde. Erstattig innerhalb vo 72 Stund.",
    sec4Item1: "Reklamation direkt im Dashboard iireiche",
    sec4Item2: "Gründ: Nid erreichbar, falschs Gwärb, keis ächts Projekt",
    sec4Item3: "Berechtigti Reklamatione wärde sofort erstattet",
    ctaTitle: "Händ Sie no Frage?",
    ctaDesc: "Kontaktiere Sie üs oder starte Sie direkt – mir stönd für Transparänz und Fairness.",
    ctaClientBtn: "Projekt professionell starte",
    ctaProviderBtn: "Meh qualifizierti Projekt sichre",
  },
};

export default deCH;
